export type Serializable =
  | boolean
  | string
  | number
  | null
  | Serializable[]
  | { [key: string]: Serializable };
